import type { JourneySubmittedAction } from '../types/actions'
import { SUBMISSION_STATUS } from '../types/enums'

import { actionFactory } from './factory'

export const journeySubmitted = actionFactory<JourneySubmittedAction>(
  (state) => {
    state.submissionState = {
      status: SUBMISSION_STATUS.SUCCESS,
      submittedAt: new Date()
    }
  },
  'journeySubmitted'
)
